import { Component, OnInit } from "@angular/core";
import { FormControl, UntypedFormBuilder } from "@angular/forms";
import {
  StringCustomFieldConfig,
  DataService,
  SharedModule,ModalService,
  FormInputComponent,
} from "@bb-vendure/admin-ui/core";
import { switchMap } from "rxjs/operators";
import SupplierDialogComponent from './components/supplier-dialog.component'
import { Observable, of } from "rxjs";
import { FetchSuppliersDocument
} from "../generated-graphql/graphql";

export type AddArtistResult = {
  artistId: string | undefined;
};

@Component({
  standalone: true,
  imports: [SharedModule],
  templateUrl: "./supplier-dropdown.component.html",
  styleUrls: ["./supplier.component.scss"],
})
export class SupplierPickerComponent
  implements FormInputComponent<StringCustomFieldConfig>, OnInit
{
  resolveWith: (result?: AddArtistResult) => void;
  constructor(
    private dataService: DataService,
    private formBuilder: UntypedFormBuilder,
    private dialog: ModalService
  ) {}

  isListInput?: boolean = false;
  readonly: boolean;
  formControl: FormControl<any>;
  config: StringCustomFieldConfig;
  suppliers$: Observable<any>;

  ngOnInit(): void {
    this.suppliers$ = this.dataService.query(FetchSuppliersDocument).mapSingle(data => data.suppliers.result.data.vendInfo)
    this.selectedSupplier = this.formControl.value;
    console.log("Form", this.formControl.value)
  }

  selectedSupplier

  selectDialog() {
    this.dialog.fromComponent(SupplierDialogComponent, {
      size: 'lg',
      closable: true,
      locals: {
        variantId: '',
      }
    }).subscribe((res) => {
      if(res){
        this.selectedSupplier = res.name
        this.formControl.setValue(res.name)
        this.formControl.markAsDirty()
      }
    })
  }

  // compareFn(item1: { id: string } | null, item2: { id: string } | null) {
  //   return item1 && item2 ? item1.id === item2.id : item1 === item2;
  // }
}
